<template>
  <div class="organ">
    <div class="top">
      <van-image
        class="top-icon"
        :src="require('../../../assets/organ-icon.png')"
      />
      <div class="top-right">
        <div class="top-right-title">{{ title }}</div>
        <div class="top-right-auth" v-if="isAuth">
          <van-image
            class="top-right-auth-icon"
            :src="require('../../../assets/organ-icon2.png')"
          />
          <div class="top-right-auth-text">机构已认证</div>
        </div>
      </div>
    </div>
    <div class="info">
      <div class="info-text">
        <div class="info-text-tit">服务类型</div>
        <div class="info-text-tab">{{ type }}</div>
      </div>
      <div class="info-text">
        <div class="info-text-tit">累计交易订单</div>
        <div class="info-text-tab">{{ count }}笔</div>
      </div>
    </div>
    <div class="info">
      <div class="info-title">其他信息</div>
      <div class="info-text">
        <div class="info-text-tit">机构地址</div>
        <div class="info-text-tab">{{ address }}</div>
      </div>
      <div class="info-text">
        <div class="info-text-tit">联系人</div>
        <div class="info-text-tab">{{ cantance }}</div>
      </div>
      <div class="info-text">
        <div class="info-text-tit">联系电话</div>
        <div class="info-text-tab">{{ canTel || '-' }}</div>
      </div>
      <div class="info-text">
        <div class="info-text-tit">机构简介</div>
        <div class="info-text-tab">{{ about || '无' }}</div>
      </div>
    </div>
    <div class="list-wrap">
      <div class="list-title">
        机构商品

        <div>
          发布商品 <span>{{ list.length }}</span
          >件
        </div>
      </div>
      <van-list
        class="list-van"
        v-if="listShow"
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <listCom v-for="item in list" :key="item.id" :item="item"></listCom>
      </van-list>
      <van-empty
        v-if="!listShow"
        class="custom-image"
        :image="require('../../../assets/coupons-none.png')"
        description="暂无数据"
      />
    </div>
  </div>
</template>
<script>
import listCom from './components/list'
import { entIntermediaryOrgDetail, orgGoodsPage } from '@api/market/index'
import { Toast } from 'vant'
export default {
  components: {
    listCom
  },
  data() {
    return {
      title: '',
      isAuth: true,
      type: '',
      count: 0,
      address: '',
      cantance: '',
      canTel: '',
      about: '',
      list: [],
      listShow: true,
      loading: true,
      finished: false,
      pageNum: 1,
      pageSize: 10
    }
  },
  mounted() {
    this.getEntIntermediaryOrgDetail()
    this.getOrgGoodsPage()
  },
  methods: {
    getEntIntermediaryOrgDetail() {
      entIntermediaryOrgDetail({ creditCode: this.$route.query.id }).then(
        res => {
          const { code, data, msg } = res.data
          if (code == '0000') {
            this.title = data.entName
            this.type = data.serviceNames
            this.count = data.orders
            this.address = data.address
            this.cantance = data.contact
            this.canTel = data.contactTel
            this.about = data.position
          } else {
            Toast(msg)
          }
        }
      )
    },
    onLoad() {
      this.pageNum++
      this.getOrgGoodsPage()
    },
    getOrgGoodsPage() {
      const params = {
        creditCode: this.$route.query.id,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }
      orgGoodsPage(params).then(res => {
        const { code, data, msg } = res.data
        if (code === '0000') {
          data.list.forEach(item => {
            this.list.push(item)
          })
          this.list = this.list.map(item => {
            return {
              ...item,
              oraimg: item.img.ossUrl
            }
          })
          this.loading = false
          if (data.list.length < this.pageSize) {
            this.finished = true
          } else {
            this.finished = false
          }
          if (this.list.length == 0) {
            this.listShow = false
          } else {
            this.listShow = true
          }
        } else {
          Toast(msg)
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.organ {
  width: 100%;
  min-height: 100vh;
  background: #f7f7f7;
}
.top {
  padding: 15px;
  background: #fff;
  display: flex;
  align-items: center;
  &-icon {
    width: 24px;
    height: 24px;
    padding: 10px;
    background: #e7f3ff;
    border-radius: 4px;
  }
  &-right {
    padding-left: 15px;
    &-title {
      font-size: 18px;
      font-weight: bold;
    }
    &-auth {
      width: fit-content;
      display: flex;
      align-items: center;
      background: #fff7ec;
      margin-top: 10px;
      border-radius: 10px;
      padding: 4px 20px 4px 8px;
      &-icon {
        display: block;
        width: 14px;
        height: 14px;
      }
      &-text {
        font-size: 12px;
        color: #ff9900;
        padding-left: 10px;
      }
    }
  }
}
.info {
  margin-top: 15px;
  &-title {
    padding: 0 15px 15px;
    font-size: 15px;
    color: #999;
  }
  &-text {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 15px;
    background: #fff;
    border-bottom: 1px solid #eee;
    &:last-child {
      border: none;
    }
    &-tit {
      font-size: 15px;
      white-space: nowrap;
    }
    &-tab {
      padding-left: 10px;
      font-size: 14px;
      color: #999;
    }
  }
}
.list-wrap {
  padding: 0 15px 15px;
  .list-title {
    display: flex;
    justify-content: space-between;
    padding: 15px 0 0;
    font-size: 15px;
    color: #999;
    span {
      color: #0080ff;
    }
  }
}
.custom-image {
  margin-top: 10%;
  /deep/.van-empty__image {
    width: 200px;
    height: 120px;
  }
  /deep/.van-empty__description {
    margin-top: -36px;
  }
}
</style>
